<div>
    <mat-icon (click)="close()">close</mat-icon>
</div>
<p [innerHtml]="value"></p>

<!-- <img [src]="value"> -->